import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-grid-row',
    templateUrl: 'cs-grid-row.html',
    host: { 'class': 'grid-row' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsGridRowComponent {
}
